export const authActions = {
    AUTHERROR: "ERROR",
    LOGOUT: "LOGOUT",
    AUTH: "AUTH",
}